export default __webpack_public_path__ + "assets/images/20f2dcfb4746fff4851200efa877bed5.jpg";